const doc = [({"zh_cn":({"adminConstantRoomPlanDisplayType":({"default":"默认", "noImage":"暂无计划图片", "onlyOne":"只有一个", "onlyPlan":"仅限计划"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;